import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { systemSettingsApi } from '@/features/admin/services/systemSettingsApi';

export interface TrayDepositRates {
  rate210Hole: number;
  rate442Hole: number;
}

const PUBLIC_SETTINGS_QUERY_KEY = ['system-settings', 'public'] as const;

/**
 * Reads the refundable tray-deposit rates from public system settings.
 * Falls back to 0 (deposits disabled) while loading or if unavailable,
 * so call sites never have to handle a "no rates yet" state.
 */
export const useTrayDepositRates = (): TrayDepositRates => {
  const { data } = useQuery({
    queryKey: PUBLIC_SETTINGS_QUERY_KEY,
    queryFn: () => systemSettingsApi.getPublic(),
    staleTime: 5 * 60 * 1000,
  });

  return useMemo(
    () => ({
      rate210Hole:
        parseFloat(data?.find((s) => s.key === 'TrayDeposit.Rate210Hole')?.value ?? '') || 0,
      rate442Hole:
        parseFloat(data?.find((s) => s.key === 'TrayDeposit.Rate442Hole')?.value ?? '') || 0,
    }),
    [data]
  );
};
